import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Grid */}
        <div className="footer-grid">
          {/* COMPANY */}
          <div className="footer-section">
            <h3 className="footer-title">COMPANY</h3>
            <ul className="footer-list">
              <li><Link to="/" className="footer-link">• Home</Link></li>
              <li><Link to="/about-us/profile" className="footer-link">• Profile</Link></li>
              <li><Link to="/about-us/philosophy" className="footer-link">• Philosophy</Link></li>
              <li><Link to="/about-us/history" className="footer-link">• History</Link></li>
            </ul>
          </div>
          {/* SERVICES */}
          <div className="footer-section">
            <h3 className="footer-title">SERVICES</h3>
            <ul className="footer-list">
              <li><Link to="/projects/iotcctv" className="footer-link">IOT & CCTV</Link></li>
              <li><Link to="/projects/solar" className="footer-link">Solar Power</Link></li>
              <li><Link to="/projects/architecturalconstruction" className="footer-link">Architecture & Construction</Link></li>
              <li><Link to="/projects/landscapegarden" className="footer-link">Garden & landscape</Link></li>
            </ul>
          </div>
          {/* NEWS & STORIES */}
          <div className="footer-section">
            <h3 className="footer-title">NEWS & STORIES</h3>
            {/* <ul className="footer-list">
              <li><Link to="/news" className="footer-link">Newsroom</Link></li>
              <li><Link to="/customer-stories" className="footer-link">Customer Stories</Link></li>
            </ul> */}
          </div>
          {/* CONTACT */}
          <div className="footer-section">
            <h3 className="footer-title">CONTACT</h3>
            <ul className="footer-contact-list">
              <li className="contact-item">
                <svg xmlns="http://www.w3.org/2000/svg" className="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>351 Nguyen Hue, Binh Long Ward <br/> Dong Nai Province</span>
              </li>
              <li className="contact-item">
                <svg xmlns="http://www.w3.org/2000/svg" className="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>Hotline: 0918 93 11 93</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Footer */}
        <div className="footer-bottom">
          <p className="footer-copyright">©2023 Phuc An Solutions Group</p>
          <div className="footer-social">
            <span className="social-text">CONNECT WITH US:</span>
            <Link to="#" className="social-link">
              <img src="/images/facebook-icon.svg" alt="Facebook" className="social-icon" />
            </Link>
            <Link to="#" className="social-link">
              <img src="/images/twitter-icon.svg" alt="Twitter" className="social-icon" />
            </Link>
            <Link to="#" className="social-link">
              <img src="/images/linkedin-icon.svg" alt="LinkedIn" className="social-icon" />
            </Link>
            <Link to="#" className="social-link">
              <img src="/images/youtube-icon.svg" alt="YouTube" className="social-icon" />
            </Link>
            <Link to="#" className="social-link">
              <img src="/images/zalo-icon.svg" alt="Zalo" className="social-icon" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 